import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/* eslint-disable @typescript-eslint/no-explicit-any */

import { fullscreenLayout, panoramaLayout } from './layout';
import { EPanoramaState } from '../Map';

/** Настройки контрола яндекс карт */

export var YControl = /*#__PURE__*/_createClass(function YControl() {
  _classCallCheck(this, YControl);
  _defineProperty(this, "addControl", function (_ref) {
    var _ref$control = _ref.control,
      type = _ref$control.type,
      onClick = _ref$control.onClick,
      yMap = _ref.yMap,
      yInstance = _ref.yInstance,
      onFullscreenControlClick = _ref.onFullscreenControlClick,
      onPanoramaStateChange = _ref.onPanoramaStateChange;
    var yControl;
    switch (type) {
      case 'GeolocationControl':
        yControl = new yInstance.control.GeolocationControl({
          options: {
            layout: 'round#buttonLayout',
            position: {
              bottom: '24px',
              left: '24px'
            }
          }
        });
        break;
      case 'FullscreenControl':
        yControl = new yInstance.control.FullscreenControl({
          options: {
            layout: yInstance.templateLayoutFactory.createClass(fullscreenLayout),
            position: {
              top: '24px',
              right: '24px'
            }
          }
        });
        yControl.events.add('fullscreenenter', function () {
          onFullscreenControlClick(true);
        });
        yControl.events.add('fullscreenexit', function () {
          onFullscreenControlClick(false);
        });
        break;
      case 'PanoramaControl':
        yControl = new yInstance.control.Button({
          options: {
            layout: yInstance.templateLayoutFactory.createClass(panoramaLayout),
            position: {
              bottom: '72px',
              right: '24px'
            }
          }
        });
        yControl.events.add(['click'], function () {
          var center = yMap.getCenter();
          yMap.getPanoramaManager().then(function (panoramaManager) {
            panoramaManager.openPlayer(center).then(function () {
              onPanoramaStateChange(EPanoramaState.PANORAMA);
              var player = panoramaManager.getPlayer();
              if (player) {
                player.events.add('destroy', function () {
                  onPanoramaStateChange(EPanoramaState.CLOSED);
                });
              }
            }).catch(function () {
              onPanoramaStateChange(EPanoramaState.NO_PANORAMA);
            });
          }).catch();
        });
        break;
    }
    if (yControl) {
      if (onClick) {
        yControl.events.add(['click'], function () {
          return onClick({
            type: type
          });
        });
      }
      yMap.controls.add(yControl);
    }
  });
});